export default __webpack_public_path__ + "static/solutions-3-46017a9332b3d9506a36f2fc9dba74b1.webp";